import { render, staticRenderFns } from "./helpText.vue?vue&type=template&id=a8d293ea&"
import script from "./helpText.vue?vue&type=script&lang=js&"
export * from "./helpText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports